<template>
  <div class="detail-dialog">
    <div class="detail-dialog-header">
      <div class="detail-dialog-header-title">
        {{ "계좌 거래 내역 권한 부여" }}
      </div>
      <div class="detail-dialog-header-button">
        <div class="custom-spacer"/>
        <v-btn
            small
            outlined
            color="primary"
            @click.stop="$emit('closeBankAccount')"
        >
          <v-icon
              small
          >
            mdi-close-box-outline
          </v-icon>
          닫기
        </v-btn>
      </div>
    </div>
    <div class="custom-spacer"/>
    <table>
      <thead>
      <tr>
        <th>업체명</th>
        <th>업체번호</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ item.rentalcompanyName }}</td>
        <td>{{ item.rentalcompanyId }}</td>
      </tr>
      </tbody>
    </table>

    <div class="custom-spacer"/>
    <div class="d-flex justify-space-between">
      <div class="d-flex justify-space-between " >
        <span v-if="computedSelectedEmployee" class="font-weight-bold">
        신청된 직원 : {{computedSelectedEmployee.userFullname}} | {{computedSelectedEmployee.loginId}}
        </span>

      </div>
      <button v-if="hasBankPermission" class="button_style" label="확인" @click.stop="onUpdateBank">
        변경하기
      </button>
      <button class="button_style" v-else label="적용" @click.stop="onGrantBank">
        적용하기
      </button>
    </div>
    <template>
      <div>
        <table border="1" style="width: 100%; border-collapse: collapse">
          <thead>
          <tr>
            <th></th>
            <th>이름</th>
            <th>로그인 ID</th>
            <th>전화번호</th>
            <th>이메일</th>
            <th>권한 그룹</th>
            <th>권한 유무</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(employee, index) in employees" :key="index">
            <td>
              <input
                  v-model="selectedUser"
                  type="radio"
                  name="selectedEmployee"
                  :value="employee.userId"
              />
            </td>
            <td>{{ employee.userFullname }}</td>
            <td>{{ employee.loginId }}</td>
            <td>{{ employee.userMobileno }}</td>
            <td>{{ employee.userEmail }}</td>
            <td>{{ employee.permissionGroupCode | translate }}</td>
            <td>{{ employee.bankAccount }}</td>
          </tr>
          </tbody>
        </table>

        <p>선택된 직원 ID: {{ selectedUser }}</p>
      </div>
    </template>
    <div class="detail-dialog-footer"/>
  </div>
</template>

<script>
import time from "../../assets/plugins/mps-common/time";
import {cloneDeep} from "lodash";
import {PATH} from "@/constants";
import {DateTime} from "luxon";
import Button from "@/components/button/Button.vue";

export default {
  name: "GrantBankAccountDialog",
  components: {},
  props: {
    item: {
      type: Object,
      default: undefined
    },
  },
  data() {
    return {
      loginId: undefined,
      confirmYn: false,
      employees: [],
      hasBankPermission: false,
      selectedEmployee: undefined,
      selectedUser: undefined,
    }
  },
  created() {
    this.loadEmployees()
  },
  computed: {
    userIdsWithBankAccount() {
      return this.employees
          .filter(emp => !!emp.bankAccount)
          .map(emp => emp.userId);
    },
    computedSelectedEmployee() {
      return this.employees.find(id => id.userId === this.selectedEmployee)
    }
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(newVal) {

      }
    },
    selectedEmployee: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if(newVal> 0) {
          this.selectedUser = newVal
        }
      }
    },
    employees: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if(newVal.length > 0) {
          this.loadRequestedEmployee()
        }
      }
    },


  },

  methods: {
    onGrantBank() {
      this.$confirm('현재 선택된 사용자에게 계좌 거래 내역 권한을 부여합니다.').then(() => this.grantBankAccount() )
    },
    onUpdateBank() {
      this.$confirm('기존 권한 소유자의 권한을 제거하고 현재 선택된 사용자로 권한을 변경합니다.').then(() => this.grantUpdateBankAccount() )
    },
    async checkLoginId() {
      try {
        const res = await this.$request(PATH.USER_PERMISSION.USER_CHECK)
            .setObject({
              rentalcompanyId: this.item.rentalcompanyId,
              loginId: this.loginId
            })
            .catch(e => {
            })
            .enqueue()
        if (res) {
          this.$alert(`사용자 이름을 확인하세요.<br> [${res.userfullName}]`)
          this.confirmYn = true
          this.userId = res.userId
        }

      } catch (e) {
        console.error(e)
      }
    },
    async loadRequestedEmployee() {
      try {
        const res = await this.$request(PATH.USER_PERMISSION.REQUESTER)
            .setObject({
              rentalcompanyId: this.item.rentalcompanyId
            })
            .catch(e => {
            })
            .enqueue()
        if (res > 0) {
          this.selectedEmployee = res
        } else {
          this.$alert('이미 계좌 거래 내역 관리자(부여) 권한이 부여된 상태입니다.')
        }

      } catch (e) {
        console.error(e)
      }
    },
    loadEmployees() {
      this.loading = true

      this.$request(PATH.USER_PERMISSION.EMPLOYEES)
          .setObject({rentalcompanyId: this.item.rentalcompanyId})
          .enqueue()
          .catch()
          .then((res) => {
            try {
              this.loading = false
              this.employees = res.data.filter((e) => e.permissionGroupCode === 'RENTAL_ADMIN')
              this.hasBankPermission = res.data.some(emp => !!emp.bankAccount)
            } catch (error) {
              console.error(error)
            }
          })
          .catch((error) => {
            console.error(error)
            this.loading = false
            this.toastError('서버에서 로드중 에러가 발생하였습니다.')
          })
    },
    async grantBankAccount() {
      try {
        const res = await this.$request(PATH.USER_PERMISSION.GRANT_BANK)
            .setObject({
              rentalcompanyId: this.item.rentalcompanyId,
              userId: this.selectedUser
            })
            .catch(e => {
            })
            .enqueue()
        if (res > 0) {
          this.$alert('계좌 거래 내역 관리자(부여) 권한이 적용됐습니다.')
          this.$emit('closeBankAccount')
        } else {
          this.$alert('이미 계좌 거래 내역 관리자(부여) 권한이 부여된 상태입니다.')
        }

      } catch (e) {
        console.error(e)
      }
    },
    async grantUpdateBankAccount() {
      try {
        const res = await this.$request(PATH.USER_PERMISSION.GRANT_BANK_UPDATE)
            .setObject({
              rentalcompanyId: this.item.rentalcompanyId,
              userId: this.selectedUser,
              originUserIds: this.userIdsWithBankAccount
            })
            .catch(e => {
            })
            .enqueue()
        if (res > 0) {
          this.$alert('계좌 거래 내역 관리자(부여) 권한이 적용됐습니다.')
          this.$emit('closeBankAccount')
        } else {
          this.$alert('이미 계좌 거래 내역 관리자(부여) 권한이 부여된 상태입니다.')
        }

      } catch (e) {
        console.error(e)
      }
    }

  },
}
</script>

<style scoped>
.button_style {
  border: 1px solid #ddd;
  width: 20%;
  height: 100%;
  background-color: #0085FF;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center
}

.detail-dialog {
  background: #fff;
  padding: 12px;
  width: 1000px;
  min-width: 1000px;
  max-width: 1000px;
}

.detail-dialog > div {
  padding: 4px 0;
}

.detail-dialog-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dddddd;
}

.detail-dialog-header-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.detail-dialog-header-button {
  display: flex;
}


.sub-content-item input,
.sub-content-item select {
  max-width: 200px;
}

input,
select {
  flex: 1;
  margin-left: 16px;
  border-bottom: 1px solid #0c98fe;
  color: #1867c0;
  outline: none;
  padding-right: 24px;
  position: relative;
}

select {
  background: url(/img/icon_selectarrow.png) no-repeat right center;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;
}

table thead tr th {
  background: #0c98fe;
  padding: 2px;
  color: white;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr:nth-child(2n) {
  background: #f4f4f4;
}

table tbody tr td {
  padding: 8px 4px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}


/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>